import { Inject, Injectable, effect, signal } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class Canonical {
  private canonicalUrlSignal = signal<string | null>(null);

  constructor(@Inject(DOCUMENT) private dom: Document) {
    effect(() => {
      const url = this.canonicalUrlSignal();
      if (!url) return;

      this.executeDomUpdate(url);
    });
  }

  setCanonicalUrl(url: string): void {
    this.canonicalUrlSignal.set(url);
  }

  private executeDomUpdate(url: string): void {
    const head = this.dom.head;
    if (!head) return;

    let element: HTMLLinkElement | null = this.dom.querySelector(`link[rel='canonical']`);

    if (!element) {
      element = this.dom.createElement('link');
      element.setAttribute('rel', 'canonical');
      head.appendChild(element);
    }

    element.setAttribute('href', url);
  }
}